// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.infoTable tr td:first-child {
  padding-right: 15px;
}

.topBar {
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  height: 85px;
  padding-top: 20px;
  padding-left: 20px;
  background-color: #eee;
  border-bottom: 1px solid #ddd;
}

.ngred {
  color: #F07B7E;
}

.topHead {
  height: 70px;
}

.topMenu, .bottomMenu {
  background-color: #eee;
  margin: 0 0 auto 102px;
  min-width: 550px;
}

.mainTitleRmSb {
  margin-top: 15px;
  font-family: "MontserratSemiBold", sans-serif;
  font-size: 22px; /** h1 usual is 28px */
}

.fakeListTable {
  width: 100%;
}

.fakeListTable tr {
  height: 20px;
}

.fakeListTable tr td:last-child {
  width: 20px;
}

.fakeItem {
  background-color: #dddddd;
  line-height: 12px;
}

.fakeIndicator {
  color: #dddddd;
}

.talentsDisplay {
  width: 100%;
}

.subTitleRmSb, .subTitleRmCai {
  margin-top: 15px;
  font-family: "MontserratSemiBold", sans-serif;
  font-size: 17px;
}

.topMenu {
  padding-top: 20px;
  border-bottom: 1px solid #ddd;
  padding-left: 20px;
}

.bottomMenu {
  padding-top: 5px;
  border-top: 1px solid #ddd;
}

.attention {
  background-color: #ff9800;
  padding: 2px 4px;
  color: #333333;
  border-radius: 3px;
}

/** affixing **/
.top {
  background-color: rgb(241, 241, 241);
  top: 0;
}

.fluid {
  position: relative;
  top: 125px;
}

.semiFluid {
  position: relative;
  top: 125px;
}

.blockBottom {
  position: fixed;
  padding-top: 20px;
}

.bbLeft {
  left: 102px;
  padding: 35px 20px 0 20px;
}

.bbRight {
  padding-right: 40px;
}

.bottomMenuRm {
  padding-bottom: 20px;
  padding-left: 20px;
}

::ng-deep .itemLoading .backdrop, ::ng-deep .itemLoading .spinner-three-bounce {
  z-index: 1999 !important;
}

.colorTitle {
  width: 100%;
  padding: 4px;
}

.graphTitle {
  padding-top: 4px;
  padding-left: 5px;
}

.countTitle {
  color: white;
  font-size: 1.5em;
  font-family: sans-serif;
  font-weight: bold;
  padding-left: 10px;
  padding-top: 12px;
}

.subCircleTitle {
  padding-top: 5px;
}

.personTitle {
  width: 220px;
  color: white;
  font-size: 1.25em;
  padding-top: 12px;
  padding-right: 4px;
}

.listsNames {
  padding-top: 2px;
}

.nameListing {
  padding: 20px;
  background-color: white;
}

.nameBox {
  padding-top: 4px;
  border-bottom: 1px solid #ddd;
}

.fakeItem {
  background-color: #eee;
  line-height: 12px;
}`, "",{"version":3,"sources":["webpack://./src/app/analysis/jobSatisfactions/components/web/job-satisfactions-sidebar/job-satisfactions-sidebar.component.scss"],"names":[],"mappings":"AAAA;EACI,mBAAA;AACJ;;AAEA;EACI,kBAAA;EACA,OAAA;EACA,QAAA;EACA,MAAA;EACA,YAAA;EACA,iBAAA;EACA,kBAAA;EACA,sBAAA;EACA,6BAAA;AACJ;;AAEA;EACI,cAAA;AACJ;;AAEA;EACI,YAAA;AACJ;;AAEA;EACI,sBAAA;EACA,sBAAA;EACA,gBAAA;AACJ;;AAEA;EACI,gBAAA;EACA,6CAAA;EACA,eAAA,EAAA,sBAAA;AACJ;;AAEA;EACI,WAAA;AACJ;;AAEA;EACI,YAAA;AACJ;;AAEA;EACI,WAAA;AACJ;;AAEA;EACI,yBAAA;EACA,iBAAA;AACJ;;AAEA;EACI,cAAA;AACJ;;AAEA;EACI,WAAA;AACJ;;AAEA;EACI,gBAAA;EACA,6CAAA;EACA,eAAA;AACJ;;AAEA;EACI,iBAAA;EACA,6BAAA;EACA,kBAAA;AACJ;;AAEA;EACI,gBAAA;EACA,0BAAA;AACJ;;AAEA;EACI,yBAAA;EACA,gBAAA;EACA,cAAA;EACA,kBAAA;AACJ;;AAEA,eAAA;AAEA;EACI,oCAAA;EACA,MAAA;AAAJ;;AAGA;EACI,kBAAA;EACA,UAAA;AAAJ;;AAGA;EACI,kBAAA;EACA,UAAA;AAAJ;;AAGA;EACI,eAAA;EACA,iBAAA;AAAJ;;AAGA;EACI,WAAA;EACA,yBAAA;AAAJ;;AAGA;EACI,mBAAA;AAAJ;;AAGA;EACI,oBAAA;EACA,kBAAA;AAAJ;;AAGA;EACI,wBAAA;AAAJ;;AAGA;EACI,WAAA;EACA,YAAA;AAAJ;;AAGA;EACI,gBAAA;EACA,iBAAA;AAAJ;;AAGA;EACI,YAAA;EACA,gBAAA;EACA,uBAAA;EACA,iBAAA;EACA,kBAAA;EACA,iBAAA;AAAJ;;AAGA;EACI,gBAAA;AAAJ;;AAGA;EACI,YAAA;EACA,YAAA;EACA,iBAAA;EACA,iBAAA;EACA,kBAAA;AAAJ;;AAGA;EACI,gBAAA;AAAJ;;AAGA;EACI,aAAA;EACA,uBAAA;AAAJ;;AAGA;EACI,gBAAA;EACA,6BAAA;AAAJ;;AAGA;EACI,sBAAA;EACA,iBAAA;AAAJ","sourcesContent":[".infoTable tr td:first-child {\n    padding-right: 15px;\n}\n\n.topBar {\n    position: absolute;\n    left: 0;\n    right: 0;\n    top: 0;\n    height: 85px;\n    padding-top: 20px;\n    padding-left: 20px;\n    background-color: #eee;\n    border-bottom: 1px solid #ddd;\n}\n\n.ngred {\n    color: #F07B7E  ;\n}\n\n.topHead {\n    height: 70px;\n}\n\n.topMenu, .bottomMenu {\n    background-color: #eee;\n    margin: 0 0 auto 102px;\n    min-width: 550px;\n}\n\n.mainTitleRmSb {\n    margin-top: 15px;\n    font-family: 'MontserratSemiBold',  sans-serif;\n    font-size: 22px; /** h1 usual is 28px */\n}\n\n.fakeListTable {\n    width: 100%;\n}\n\n.fakeListTable tr {\n    height: 20px;\n}\n\n.fakeListTable tr td:last-child {\n    width: 20px;\n}\n\n.fakeItem {\n    background-color: #dddddd;\n    line-height: 12px;\n}\n\n.fakeIndicator {\n    color: #dddddd;\n}\n\n.talentsDisplay {\n    width: 100%;\n}\n\n.subTitleRmSb, .subTitleRmCai {\n    margin-top: 15px;\n    font-family: 'MontserratSemiBold',  sans-serif;\n    font-size: 17px;\n}\n\n.topMenu {\n    padding-top: 20px;\n    border-bottom: 1px solid #ddd;\n    padding-left: 20px;\n}\n\n.bottomMenu {\n    padding-top: 5px;\n    border-top: 1px solid #ddd;\n}\n\n.attention {\n    background-color: #ff9800;\n    padding: 2px 4px;\n    color: #333333;\n    border-radius: 3px;\n}\n\n/** affixing **/\n\n.top {\n    background-color: rgb(241, 241, 241);\n    top: 0;\n}\n\n.fluid {\n    position: relative;\n    top: 125px;\n}\n\n.semiFluid {\n    position: relative;\n    top: 125px;\n}\n\n.blockBottom {\n    position: fixed;\n    padding-top: 20px;\n}\n\n.bbLeft {\n    left: 102px;\n    padding: 35px 20px 0 20px;\n}\n\n.bbRight {\n    padding-right: 40px;\n}\n\n.bottomMenuRm {\n    padding-bottom: 20px;\n    padding-left: 20px;\n}\n\n::ng-deep .itemLoading .backdrop, ::ng-deep .itemLoading .spinner-three-bounce {\n    z-index: 1999 !important;\n}\n\n.colorTitle {\n    width: 100%;\n    padding: 4px;\n}\n\n.graphTitle {\n    padding-top: 4px;\n    padding-left: 5px;\n}\n\n.countTitle {\n    color: white;\n    font-size: 1.5em;\n    font-family: sans-serif;\n    font-weight: bold;\n    padding-left: 10px;\n    padding-top: 12px\n}\n\n.subCircleTitle {\n    padding-top: 5px\n}\n\n.personTitle {\n    width: 220px;\n    color: white;\n    font-size: 1.25em;\n    padding-top: 12px;\n    padding-right: 4px;\n}\n\n.listsNames {\n    padding-top: 2px\n}\n\n.nameListing {\n    padding: 20px;\n    background-color: white;\n}\n\n.nameBox {\n    padding-top: 4px;\n    border-bottom: 1px solid #ddd;\n}\n\n.fakeItem {\n    background-color: #eee;\n    line-height: 12px;\n}\n\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
